module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-cover bg-overlay-black-6",
    style: ('height:' + _vm.windowHeight + 'px!important'),
    attrs: {
      "id": "register"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-5"
  }, [_c('div', {
    staticClass: "form-wrapper border-round padding-8"
  }, [(!_vm.disabled) ? _c('div', {
    attrs: {
      "id": "mc_embed_signup"
    }
  }, [(!_vm.submitted) ? _c('form', {
    staticClass: "validate",
    attrs: {
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.register()
      }
    }
  }, [_c('div', {
    staticClass: "form-val-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.CNAME),
      expression: "body.CNAME"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Virksomhed"
    },
    domProps: {
      "value": (_vm.body.CNAME)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "CNAME", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-val-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.FNAME),
      expression: "body.FNAME"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Fulde navn"
    },
    domProps: {
      "value": (_vm.body.FNAME)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "FNAME", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-val-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.EMAIL),
      expression: "body.EMAIL"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "type": "email",
      "placeholder": "E-mail adresse"
    },
    domProps: {
      "value": (_vm.body.EMAIL)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "EMAIL", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-val-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.PHONE),
      expression: "body.PHONE"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Telefon"
    },
    domProps: {
      "value": (_vm.body.PHONE)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "PHONE", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('button', {
    staticClass: "form-submit btn btn-base-color btn-medium button",
    attrs: {
      "type": "submit",
      "name": "subscribe",
      "id": "mc-embedded-subscribe",
      "disabled": !_vm.isValidated
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("Tilmeld")]) : _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])])]) : _c('div', {
    staticClass: "submit-success"
  }, [_c('h3', [_vm._v("\n                                Tak for din tilmelding!\n                            ")]), _vm._v(" "), _c('p', [_vm._v("\n                                Du vil modtage nærmere info via e-mail snarest.\n                            ")])])]) : _c('div', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("\n                        Dato for næste arrangement kommer snart, hvorefter du kan tilmelde dig her på siden.\n                    ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-md-7 xs-text-center"
  }, [_c('span', {
    staticClass: "display-block font-family-alt letter-spacing-1 opacity-9 margin-7 no-margin-bottom no-margin-rl text-white text-medium text-uppercase"
  }, [_vm._v("Tilmeld dig allerede nu!")]), _vm._v(" "), _c('h2', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-2 margin-5 no-margin-bottom no-margin-rl text-white xs-title-medium title-extra-large-3 text-uppercase vw-bold"
  }, [_vm._v("Vil du med?"), _c('br'), _vm._v("Tilmeld dig her")]), _vm._v(" "), _c('span', {
    staticClass: "bg-base-color display-inline-block margin-5-5 no-margin-rl separator-line-medium-thick-long"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newsletter-wrapper"
  }, [_c('span', [_c('a', {
    attrs: {
      "rel": "noopener",
      "target": "_blank",
      "href": "https://www.volkswagen-erhvervsbiler.dk/app/web/erhverv/tilmeld-nyhedsbrev/"
    }
  }, [_vm._v("\n                                        Tilmeld dig vores nyhedsbrev →\n                                    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d205692a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home-sections/registration.vue
// module id = 249
// module chunks = 1